import { Expose, instanceToPlain, plainToInstance, Transform } from 'class-transformer'
import type { PersonResponse as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'
import FamilyResponse from '@/services/api/transformers/FamilyResponse'

export type SerializedPersonResponse = Model

export default class PersonResponse implements CamelCaseKeys<SerializedPersonResponse> {
    name?: Model['name']

    @Expose({ name: 'family_id' })
    familyId?: Model['family_id']

    archived?: Model['archived']

    @Expose({ name: 'profile_picture' })
    profilePicture?: Model['profile_picture']

    @Transform(({ value }) => plainToInstance(FamilyResponse, value), { toClassOnly: true })
    @Transform(({ value }) => instanceToPlain(value), { toPlainOnly: true })
    family?: FamilyResponse

    constructor(values: PersonResponse) {
        Object.assign(this, values)
    }
}
